<template>
  <div class="client-selector">
    <button
      class="mds-button mds-button--flat client-selector__button"
      type="button"
      @click="onSelect"
    >
      <span class="mds-button__text client-selector__button-text">{{ selectedText }}</span>
      <svg
        class="mds-icon mds-button__icon mds-button__icon--right client-selector__button-icon"
        aria-hidden="true"
        v-show="canSelect"
      >
        <use xlink:href="static/mds/icons/mds.svg#caret-down"></use>
      </svg>
    </button>
  </div>
</template>

<script>
export default {
  name: 'client-selector',
  props: {
    selectedText: {
      type: String,
      required: true,
    },
    canSelect: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    onSelect() {
      this.$emit('onSelect');
    },
  },
};
</script>

<style lang="scss">
.client-selector {
  margin: $mds-space-2-and-a-half-x $mds-space-2-and-a-half-x $mds-space-2-and-a-half-x $mds-space-2-x;
  &__selected {
    font-family: $mds-font-family-sans-serif;
    font-size: $mds-font-size-s;
    margin: 0;
  }
  &__button:hover &__button-icon.mds-icon.mds-button__icon {
    fill: $mds-color-white;
  }
  &__button-text {
    color: $mds-color-white;
  }
  &__button-icon.mds-icon.mds-button__icon {
    fill: $mds-color-white;
  }
  &__button-icon.mds-icon.mds-button__icon:hover {
    fill: $mds-color-white;
  }
}
</style>
